/**
 * Visits a consultant can take in the same hour through the ADM (clients self-schedule
 * up to 2 on the site). Several visits in one hour must be for the same property, so the
 * consultant is never in two places: new visits reuse the property already booked.
 */
export const ADM_MAX_VISITS_PER_SLOT = 4;

export function canScheduleAnotherVisitInSlot(visitsInSlot: number): boolean {
  return visitsInSlot < ADM_MAX_VISITS_PER_SLOT;
}

export function resolveAppointmentPropertyId(
  property: Record<string, unknown> | null | undefined
): number | null {
  const id = Number(property?.id);
  return Number.isInteger(id) && id > 0 ? id : null;
}
